import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../../base/BaseEntity'
import { generateEntityId } from '../../generateEntityId'

/** A purchasable credit bundle shown in the Buy Credits catalog — a `CreditPurchase` snapshots its values at purchase time. */
@ObjectType()
@InputType('CreditPackageInput')
@modelOptions({ schemaOptions: { timestamps: true, collection: 'aicreditpackages' } })
export class CreditPackage extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('crpk') })
  declare _id: string

  @Field(() => String)
  @Prop({ type: String, required: true })
  declare name: string

  @Field(() => Float)
  @Prop({ type: Number, required: true })
  credits: number

  /** Major units (pesos), never minor/cent units. */
  @Field(() => Float)
  @Prop({ type: Number, required: true })
  price: number

  @Field(() => String)
  @Prop({ type: String, required: true })
  currency: string

  @Field(() => Boolean)
  @Prop({ type: Boolean, required: true, default: true })
  active: boolean

  @Field(() => Float)
  @Prop({ type: Number, required: true })
  sortOrder: number
}
